import type { NavigateFunction } from 'react-router-dom'
import { format } from 'date-fns'
import { ro } from 'date-fns/locale'

import { getCountryPhoneCodes, renderDecimalNumber } from '@leanpay/utils'

import { CreditRoute, currentMarket, HANDOFF_LANDING_ROUTE, isProdEnvironment } from './constants'

export const countryPhoneCodes = getCountryPhoneCodes(currentMarket, isProdEnvironment)

// All later steps replace the history entry. The tokenless "/" below the landing keeps browser
// Back in this app and shows the error screen, as after OTP login. It also removes the handoff URL.
export const navigateToHandoffLanding = (navigate: NavigateFunction) => {
    navigate('/', { replace: true })
    navigate(`/${HANDOFF_LANDING_ROUTE}`)
}

export const handleCreditProgress = (route: string, setProgress: (progress: number) => void) => {
    switch (route.replace('/', '') as CreditRoute) {
        case CreditRoute.RequestOtp:
            setProgress(10)
            break
        case CreditRoute.Login:
            setProgress(20)
            break
        // SLO ValidationCheck / EnterAmount share the flow position of ROM Consents / ValidateOffer.
        case CreditRoute.Consents:
        case CreditRoute.ValidationCheck:
        case CreditRoute.TwoFaPin:
            setProgress(25)
            break
        case CreditRoute.ValidateOffer:
        case CreditRoute.EnterAmount:
            setProgress(30)
            break
        case CreditRoute.OfferPlanData:
            setProgress(40)
            break
        case CreditRoute.EnterIban:
            setProgress(50)
            break
        case CreditRoute.ScoringDecision:
            setProgress(55)
            break
        case CreditRoute.OfferConfirmation:
            setProgress(65)
            break
        case CreditRoute.SignContract:
            setProgress(75)
            break
        case CreditRoute.PepQuestionnaire:
            setProgress(80)
            break
        case CreditRoute.CreditSuccess:
            setProgress(100)
            break
        case CreditRoute.CreditRejection:
            setProgress(100)
            break
        case CreditRoute.CreditError:
            setProgress(100)
            break
        default:
            setProgress(0)
            break
    }
}

export const shouldShowProgressBar = () => {
    const progressBarExcludedPaths = ['/']

    return !progressBarExcludedPaths.includes(window.location.pathname)
}

export const displayDecimalNumber = (value?: string | number) =>
    renderDecimalNumber(value, currentMarket)

export const formatPercent = (rate: number): string => `${displayDecimalNumber(rate)}%`

export const formatRoDate = (timestamp: number): string =>
    format(new Date(timestamp), 'dd MMM yyyy', { locale: ro }).toLowerCase()

export const getMonthLabel = (numberOfMonths?: number): string => {
    if (!numberOfMonths || numberOfMonths !== 1) return 'months'
    return 'month'
}
